module.exports = __webpack_public_path__ + "static/KON-mobile-0292cf3c927d7b93f0aa8839bff594e3.png";